import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatStepperModule } from '@angular/material/stepper';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CreateCommunicationDialogComponent } from './communications/create-communication-dialog/create-communication-dialog.component';
import { CondominiumComponent } from './condominium/condominium.component';
import { CreateComponent } from './condominium/create/create.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CallbackComponent } from './login/callback/callback.component';
import { SignupComponent } from './login/signup/signup.component';
import { HomeComponent } from './home/home.component';
import { CondominiumService } from './services/condominium.service';
import { SilentAuthService } from './services/silent-auth.service';
import { UserService } from './services/user.service';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommunicationsComponent } from './communications/communications.component';
import { TasksSummaryComponent } from './dashboard/tasks-summary/tasks-summary.component';
import { TaskDetailComponent } from './task/task-detail/task-detail.component';
import { TaskCreateComponent } from './task/task-create/task-create.component';
import { TaskSummaryTileComponent } from './shared/task-summary-tile/task-summary-tile.component';
import { TasksAllComponent } from './task/tasks-all/tasks-all.component';
import { GenericConfirmationDialogComponent } from './shared/delete-confirmation-dialog/generic-confirmation-dialog.component';
import { TicketsSummaryComponent } from './dashboard/tickets-summary/tickets-summary.component';
import { TicketDetailComponent } from './ticket/ticket-detail/ticket-detail.component';
import { TicketCreateComponent } from './ticket/ticket-create/ticket-create.component';
import { TicketsAllComponent } from './ticket/tickets-all/tickets-all.component';
import { AuthService } from './services/auth.service';
import { TicketService } from './services/ticket.service';
import { TicketSummaryTileComponent } from './shared/ticket-summary-tile/ticket-summary-tile.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToolbarComponent } from './shared/toolbar/toolbar.component';
import { CommunicationSummaryTileComponent } from './shared/communication-summary-tile/communication-summary-tile.component';
import { CommunicationsSummaryComponent } from './dashboard/communications-summary/communications-summary.component';
import { CommunicationDetailsComponent } from './communications/communication-details/communication-details.component';
import { CondominiumLayoutComponent } from './condominium/condominium-layout/condominium-layout.component';
import { MatListModule } from '@angular/material/list';
import { InvitationService } from './services/invitation.service';
import { CreateInvitationDialogComponent } from './invitation/create-invitation-dialog/create-invitation-dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AllComponent } from './invitation/all/all.component';
import { InvitationCreateComponent } from './invitation/invitation-create/invitation-create.component';
import { InvitationResponseComponent } from './invitation/invitation-response/invitation-response.component';
import { CookieService } from 'ngx-cookie-service';
import { UserFormComponent } from './shared/user-form/user-form.component';
import { CondominiumFormComponent } from './shared/condominium-form/condominium-form.component';
import { ProfileComponent } from './profile/profile.component';
import { RegistrationComponent } from './condominium/registration/registration.component';
import { MembersComponent } from './condominium/members/members.component';
import { InfoComponent } from './condominium/info/info.component';
import { MatTableModule } from '@angular/material/table';
import { ChangeOwnerComponent } from './condominium/change-owner/change-owner.component';
import { MatCardModule as _MatCardModule } from '@angular/material/card';
import { MatDialogModule as _MatDialogModule } from '@angular/material/dialog';
import { MatIconModule as _MatIconModule } from '@angular/material/icon';
import { AlertDialogComponent } from './shared/alert-dialog/alert-dialog.component';
import { SubscriptionPlanSelectorComponent } from './shared/subscription-plan-selector/subscription-plan-selector.component';
import { CondominiumSubscriptionComponent } from './condominium/condominium-subscription/condominium-subscription.component';
import { CondominiumPaymentsComponent } from './condominium/condominium-payments/condominium-payments.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { EmailConfirmationReminderComponent } from './email-confirmation-reminder/email-confirmation-reminder.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        EmailConfirmationComponent,
        EmailConfirmationReminderComponent,
        CallbackComponent,
        SignupComponent,
        DashboardComponent,
        CondominiumComponent,
        CreateComponent,
        CommunicationsComponent,
        CreateCommunicationDialogComponent,
        TasksSummaryComponent,
        TaskDetailComponent,
        TaskCreateComponent,
        TaskSummaryTileComponent,
        TasksAllComponent,
        GenericConfirmationDialogComponent,
        TicketsSummaryComponent,
        TicketDetailComponent,
        TicketCreateComponent,
        TicketsAllComponent,
        TicketSummaryTileComponent,
        ToolbarComponent,
        CommunicationSummaryTileComponent,
        CommunicationsSummaryComponent,
        CommunicationDetailsComponent,
        CondominiumLayoutComponent,
        CreateInvitationDialogComponent,
        AllComponent,
        InvitationCreateComponent,
        InvitationResponseComponent,
        UserFormComponent,
        CondominiumFormComponent,
        ProfileComponent,
        RegistrationComponent,
        MembersComponent,
        InfoComponent,
        ChangeOwnerComponent,
        AlertDialogComponent,
        CondominiumSubscriptionComponent,
        CondominiumPaymentsComponent
    ],
    bootstrap: [AppComponent    ], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        MatSnackBarModule,
        MatDividerModule,
        MatChipsModule,
        MatDialogModule,
        MatDatepickerModule,
        MatSelectModule,
        MatNativeDateModule,
        CommonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatButtonToggleModule,
        MatMenuModule,
        MatBadgeModule,
        MatTableModule,
        MatStepperModule,
        NgxMaskDirective,
        SubscriptionPlanSelectorComponent
    ], providers: [
        AuthService,
        CondominiumService,
        UserService,
        TicketService,
        SilentAuthService,
        InvitationService,
        CookieService,
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
